import { IonButton, IonInput, IonLabel, IonList, IonItem, IonButtons, IonContent, IonHeader, IonPage, IonTitle, IonToolbar 
  ,IonGrid, IonThumbnail
  ,IonRow, IonItemDivider, IonCard 
  ,IonCol, IonImg, IonRadioGroup, IonFab, IonFooter, IonActionSheet, IonFabButton, IonIcon, IonAlert
  ,IonListHeader, IonRadio, IonCheckbox, IonTextarea } from '@ionic/react';
import React, { useState, useEffect } from 'react';
//import { useParams } from 'react-router';
import './WpInspection.css';
import OpenMenuButton from "../../../components/OpenMenuButton";
import { useParams } from 'react-router';
import ServerService from '../../../services/Server';
import { useHistory } from 'react-router-dom';
import { camera, trash, close,checkmarkDoneOutline, checkmarkCircle, qrCodeOutline, documentText, shieldCheckmarkOutline, clipboardOutline
, chevronBackOutline , chevronForwardOutline, checkmarkDoneCircleOutline, calendar, personCircle, map, informationCircle, save
} from 'ionicons/icons';
import { usePhotoGallery, UserPhoto } from "../../../hooks/usePhotoGallery";
import { setAuthPersisted } from '../../../services/pinUtils';
type WpFormParams = {
  id:string, 
  dummy:string
}

const WpQc: React.FC = () => {
const { photos,takePhoto, deletePhoto} = usePhotoGallery();
const [photoToDelete, setPhotoToDelete] = useState<UserPhoto>();
const server = new ServerService();
const history = useHistory();
server.setHistory(history);
const [accountName, setAccountName] = useState(server.accounts[server.activeAcc].name);
const {id, dummy} = useParams<WpFormParams>();
const [barCode, setBarcode] = useState("");
const [qcList, setQcList] = useState([]);
const [qcLowList, setQcLowList] = useState([]);
const [qcLowAirList, setQcLowAirList] = useState([]);
const [qcListHide, setQcHide] = useState([]);
const [changeRadio, setChangeRadio] = useState();
const [items, setItems] = useState([]);
const [hideQc, setHideQc] = useState(true);
const [hideDetail, setHideDetail] = useState(false);
const [hideLowAir, setHideLowAir] = useState(true);
const [hideBtnLowAir, setHideBtnLowAir] = useState(true);

const [hideHot, setHideHot] = useState(true);
const [hideBtnHot, setHideBtnHot] = useState(true);
const [hotColor, setHotColor] = useState("light");
const [qcHotList, setQcHotList] = useState([]);

const [lowAirType, setLowAirType] = useState(false);
const name:string = "Inspection";

const [docColor, setDocColor] = useState("tertiary");
const [lowAirColor, setLowAirColor] = useState("light");
const [qcColor, setQcColor] = useState("light");

const [docid, setDocId] = useState("");
const [authorname, setAuthorname] = useState("");
const [authorcompany, setAuthorcompany] = useState("");
const [authoridcard, setAuthoridcard] = useState("");
const [authorposition, setAuthorposition] = useState("");
const [authortelephone, setAuthortelephone] = useState("");
const [worklocation, setWorklocation] = useState("");
const [workbuilding, setWorkbuilding] = useState("");
const [workfloor, setWorkfloor] = useState("");
const [workdate, setWorkdate] = useState("");
const [worktime, setWorktime] = useState("");
const [areaownertel, setAreaownertel] = useState("");
const [workextendtime, setWorkextendtime] = useState("");
const [workextendremark, setWorkextendremark] = useState("");
const [requestwork, setRequestwork] = useState([]);
const [projectdetail, setProjectdetail] = useState([]);
const [projectname, setProjectname] = useState("");
const [attach, setAttach] = useState([]);
const [equipment, setEquipment] = useState([]);
const [protection, setProtection] = useState([]);
const [areaname, setAreaName] = useState("");
const [worktimetype, setWorktimetype] = useState("");

const [comment, setComment] = useState("");
const [commentList, setCommentList] = useState([]);
const [checkValueList, setCheckValueList] = useState([]);
const [docCheckIdList, setDocCheckIdList] = useState([]);
const [hideSend, setHideSend] = useState(true);
const [hideTimeButton, setHideTimeButton] = useState(false);

const [qcTime1, setQcTime1] = useState(false);
const [qcTime2, setQcTime2] = useState(false);
const [qcTime3, setQcTime3] = useState(false);
const [showAlert, setshowAlert] = useState(false);


const [buttonColorTime1, setButtonColorTime1] = useState("");
const [buttonColorTime2, setButtonColorTime2] = useState("");
const [buttonColorTime3, setButtonColorTime3] = useState("");
const [buttonIconTime1, setButtonIconTime1] = useState("protection");
const [buttonIconTime2, setButtonIconTime2] = useState("vest");
const [buttonIconTime3, setButtonIconTime3] = useState("safety-helm");

const [useQc, setUseQc] = useState(0);
const [qcTitle, setQcTitle] = useState("");

const [qcBefor, setQcBefor] = useState("");
const [qcProcess, setQcProcess] = useState("");

const [isLowAir, setIsLowAir] = useState(false);
const [isHot, setIsHot] = useState(false);
const [isHight, setIsHight] = useState(false);
const [lastPage, setLastPage] = useState(0);

const [min1, setMin1] = useState(false);
const [min2, setMin2] = useState(false);
const [min3, setMin3] = useState(false);
const [min4, setMin4] = useState(false);

const [minD1, setMinD1] = useState(false);
const [minD2, setMinD2] = useState(false);
const [minD3, setMinD3] = useState(false);
const [minD4, setMinD4] = useState(false);
//const [checkValue, setCheckValue] = useState("");
//const [docCheckId, setDocCheckId] = useState("");


type Item = {
  doccheckid: string;
  labeltext: string;
  hide : boolean;
};
type LowAir = {
  doccheckid: string;
  value: string;
  flaglowair :string;
  qcremark :string;
  remarklowair :string;
  qcresult :string;
};
type QcHot = {
  doccheckid: string;
  value: string;
  flaglowair :string;
  qcremark :string;
  remarklowair :string;
  qcresult :string;
  flag1 :string;
  qcCheck :boolean;
  qcBy :string;
};
type Qc = {
  doccheckid: string;
  value: string;
  flaglowair :string;
  qcremark :string;
  remarklowair :string;
  qcresult :string;
};
type Image = {
  img: string;
};
//const items: Item[] = [
//{ doccheckid : 'docqc01',  labeltext : 'มีเอกสารWORK PERMIT ตามประเภทงานถูกต้อง/ ติดบัตร Contractor ตลอดเวลาที่ปฎิบัติงาน', hide : false }
//,{  doccheckid : 'docqc02',  labeltext : 'สุ่มตรวจผู้ปฏิบัติงานว่าได้ผ่านการอบรมSafetyและรับทราบกฎระเบียบเกี่ยวกับความปลอดภัยในการทำงานแล้ว' , hide : true}
//,{  doccheckid : 'docqc03',  labeltext : 'ได้ปิดกั้นบริเวณทำงานหรือแยกอุปกรณ์ที่ไม่เกี่ยวข้องออก/ ติดตั้งป้ายเตือนต่างๆ อย่างเหมาะสม' , hide : true}
//];
const list:any = [];
const listInit:any = [];


const initQcHide = function(t:any) {
  console.log('init');
  var row = 0;
  for(var Item in t ){
   
    if(row==0){
      list.push(false);
      qcListHide.push(false);
    }else{
      list.push(true);
      qcListHide.push(true);
    }
    docCheckIdList[row] = t[row].doccheckid;
    checkValueList[row] = "A";
    
    // const s:Qc = {doccheckid : t[row].doccheckid, value : "A", flaglowair : "1", qcremark : "", remarklowair : "", qcresult : "1"};
    // listInit.push(s);
    ///qcList[row] = s;
    row ++;
    console.log('For');
  }
 // setQcList(listInit);

}
const initQcLow = function(t:any) {
  console.log('init initQcLow');
  var row = 0;
  for(var Item in t ){
   // console.log('init initQcLow ::  ' + t[row].doccheckid);
    const s:LowAir = {doccheckid : t[row].doccheckid, value :"", flaglowair : "", qcremark : "" , remarklowair : "", qcresult : ""};
    qcLowList[row] = s;
    row ++;
   
  }
 

}
const initQcHot = function(t:any) {
  console.log('init initQcHot');
  var row = 0;
  for(var Item in t ){
    console.log('init initQcHot ::  ' + t[row].doccheckid);
    if(t[row].doccheckid=='MIN1' && t[row].qc_check){
        setMin1(true);
        setMinD1(true);
    }
    if(t[row].doccheckid=='MIN2' && t[row].qc_check){
      setMin2(true);
      setMinD2(true);
    }
    if(t[row].doccheckid=='MIN3' && t[row].qc_check){
      setMin3(true);
      setMinD3(true);
    }
    if(t[row].doccheckid=='MIN4' && t[row].qc_check){
      setMin4(true);
      setMinD4(true);
   }
    const s:QcHot = {doccheckid : t[row].doccheckid, value :"", flaglowair : "false", qcremark : "" , remarklowair : "", qcresult : "", flag1:"",qcCheck:t[row].qc_check,qcBy:t[row].qc_by};
    qcHotList[row] = s;
    row ++;
   
  }
 

}
const data = {
  docid: id
}

const fetchQc = function(status:any) {

  fetch(server.getFullUrl("wp/mb/getQcDocDetail", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      console.log('fetchQc');
      initQcHide(result.doccheck);
      setItems(result.doccheck);
     
      console.log(qcListHide);
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {

})
 
}
const fetchLowAir = function(status:any) {

  fetch(server.getFullUrl("wp/mb/getQcDocLowAir", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      console.log('fetchLowAir');
       setQcLowAirList(result.doccheck);
      initQcLow(result.doccheck);
   
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {

})
 
}
const fetchHot = function(status:any) {

  fetch(server.getFullUrl("wp/mb/getQcDocHot", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      console.log('fetchHot');
      setQcHotList(result.doccheck);
      initQcHot(result.doccheck);
   
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {

})
 
}
const fetchWp = function(status:any) {

  fetch(server.getFullUrl("wp/mb/getQcDoc", data),server.getRequest())
  .then(res => res.json()
  .then(
    (result) => {
      console.log('fetchWp');
      setDocId(result.docid);
      setAuthorname(result.authorname);
      setAuthorcompany(result.authorcompany);
      setAuthoridcard(result.authoridcard);
      setAuthorposition(result.authorposition);
      setAuthortelephone(result.authortelephone);
      setWorklocation(result.worklocation);
      setWorkbuilding(result.workbuilding);
      setWorkfloor(result.workfloor);
      setWorkdate(result.workdate);
      setWorktime(result.worktime);
      setAreaownertel(result.areaownertel);
      setWorkextendtime(result.workextendtime);
      setWorkextendremark(result.workextendremark);
      setRequestwork(result.requestworktype);
      setProjectdetail(result.projectdetail);
      setAttach(result.attach);
      setEquipment(result.equipment);
      setProtection(result.protection);
      setAreaName(result.areaname);
      setWorktimetype(result.worktimetype);
      setLowAirType(result.isLowAir);
      if(result.first_qc){
        setQcTime1(true);
        setButtonIconTime1("mark");
        setButtonColorTime1("success");
      }
      if(result.process_qc){
        setQcTime2(true);
        setButtonIconTime2("mark");
        setButtonColorTime2("success");
      }
      if(result.close_qc){

      }
      if(result.isLowAir){
        setIsLowAir(true);
        fetchLowAir(data);
        setHideBtnLowAir(false);
      }
      if(result.isHot){
        setIsHot(true);
        fetchHot(data);
        setHideBtnHot(false);
      }
      if(result.isHight){
        setIsHight(true);
      }
      //setHideBtnHot(false);
    },
    (error) => {

    }
 ).catch(e => {

 })
).catch(e => {

})
 
}
var params: any = {
  "docid": id,
  "doccheck":"",
  "imagelist":"",
}
const onSendQc =  function(t:any) {
  onSaveQc(t);
  var imagelist:any = [];
  photos.map((photo, index) =>  imagelist.push({"img" : photo.base64Data}))
  if((isHot || isLowAir || isHight) && useQc==3){
    if(imagelist.length == 0){
      console.log('Please select image');
      setshowAlert(true);
      return false;
    }
  }
  //photos.map((photo, index) =>  console.log(photo.base64Data))

  params.imagelist = JSON.stringify(imagelist);
  params.doccheck = JSON.stringify(qcList);
  // var img:Image={"img" : photo.webviewPath});
  
  //console.log(imagelist[0].img);
  //for(var p:any in photos.map){
  //  const list:Image = {"img":p.webviewPath};
 // }
  const formData = new FormData();
  formData.append("docid",id);
  formData.append("imagelist",JSON.stringify(imagelist));
  formData.append("doccheck",  JSON.stringify(qcList));
  formData.append("docchecklowair",  JSON.stringify(qcLowList));
  formData.append("doccheckhot",  JSON.stringify(qcHotList));
  formData.append("useQc",  String(useQc));


  
  fetch(server.getPrefixUrl()+"wp/mb/saveQcNewV2", server.uploadRequest(formData)
  ).then(
    response => response.json() // if the response is a JSON object
  ).then(res => {
    setAuthPersisted();
    window.location.href = "/page/home/wp/wpIns/0/1";
   
  }).catch(
    error => {
     
      console.log(error) // Handle the error response object
    }
  );
 
}

const onClickSaveHot = function() {
  
  const formData = new FormData();
  formData.append("docid",id);
  formData.append("doccheckhot",  JSON.stringify(qcHotList));

  fetch(server.getPrefixUrl()+"wp/mb/saveQcHot", server.uploadRequest(formData)
  ).then(
    response => response.json() // if the response is a JSON object
  ).then(res => {
    setAuthPersisted();
    window.location.href = "/page/home/wp/wpIns/0/1";
   
  }).catch(
    error => {
     
      console.log(error) // Handle the error response object
    }
  );

}
useEffect(() => {
  fetchQc("");
  fetchWp("");
}, [])


var page = 0;
var currentPage = 0;
var total = items.length;
const onClickBarcode = function(status:any) {
  
}

const onClickDocQc = function( detail:any , low:any, qc:any, hot:any) {
  
  setHideQc(qc);
  setHideTimeButton(!qc);
  //setButtonIconTime1(checkmarkDoneOutline);
  setHideDetail(!detail);
  setHideLowAir(!low);
  setHideHot(!hot);
  if(qc){
    setQcColor("tertiary");
    setDocColor("light");
    setLowAirColor("light");
    setHotColor("light");
    if(useQc!=0){
      setHideQc(!qc);
      setHideTimeButton(qc);
    }
  }
  if(detail){
    setDocColor("tertiary");
    setQcColor("light");
    setLowAirColor("light");
    setHotColor("light");
    setHideQc(true);
    setHideTimeButton(true);
  }
  if(low){
    setDocColor("light");
    setQcColor("light");
    setLowAirColor("tertiary");
    setHotColor("light");
    setHideQc(true);
    setHideTimeButton(true);
  }
  if(hot){
    setDocColor("light");
    setQcColor("light");
    setLowAirColor("light");
    setHotColor("tertiary");
    setHideQc(true);
    setHideTimeButton(true);
  }
}
const getTxtValues = function(v:any, t:any, cPage:any){

  const s:LowAir = {doccheckid : t.doccheckid, value : "", flaglowair : "true", qcremark :  "" , remarklowair : v.target.value, qcresult : "1"};
  qcLowList[cPage] = s;
  console.log(qcLowList);
  //console.log(v.target.value);
}
const getChkValues = function(v:any, t:any, cPage:any){
  console.log('getChkValues');
  var flaglowair:any = "false";
  if(v.detail.checked){
    flaglowair = "true";
  }
  const s:LowAir = {doccheckid : t.doccheckid, value : v.detail.checked, flaglowair : flaglowair,  qcremark : "" , remarklowair : "", qcresult : "1"};
  qcLowList[cPage] = s;
  console.log(qcLowList);
  //console.log(v.detail.checked);
}
const getTxtHotValues = function(v:any, t:any, cPage:any){

  const s:QcHot = {doccheckid : t.doccheckid, value : "", flaglowair : "true", qcremark :  "" , remarklowair : v.target.value, qcresult : "1" , flag1:"",qcCheck:false,qcBy:"UPDATE"};
  qcHotList[cPage] = s;
  console.log(qcHotList);
  //console.log(v.target.value);
}
const getChkHotValues = function(v:any, t:any, cPage:any){
  console.log('getChkHotValues');
  var flaglowair:any = "false";
  if(v.detail.checked){
    flaglowair = "true";
  }
  var row=0;
 
  for(var item in qcHotList ){
  
    if(qcHotList[row].doccheckid==t){
      cPage = row;
    }
    row ++;
   
  }
  if(t=='MIN1'){
    setMin1(v.detail.checked);
  }
  if(t=='MIN2'){
    setMin2(v.detail.checked);
  }
  if(t=='MIN3'){
    setMin3(v.detail.checked);
  }
  if(t=='MIN4'){
    setMin4(v.detail.checked);
  }
  const s:QcHot = {doccheckid : t, value : v.detail.checked, flaglowair : flaglowair,  qcremark : "" , remarklowair : "", qcresult : "1", flag1:"",qcCheck:false,qcBy:"UPDATE"};
  //const s:QcHot = {doccheckid : t.doccheckid, value : v.detail.checked, flaglowair : flaglowair,  qcremark : "" , remarklowair : "", qcresult : "1", flag1:"",qcCheck:false,qcBy:"UPDATE"};
  qcHotList[cPage] = s;
  console.log(qcHotList);
  //console.log(v.detail.checked);
}
const saveComment = function(c:any, i:any) {
  setComment(c);
  commentList[i] = c;
}
const onSaveQc = function(cPage:any) {
  var comment = "";
  if(commentList[cPage]!=null){
    comment = commentList[cPage];
  }
  const s:Qc = {doccheckid : docCheckIdList[cPage], value : checkValueList[cPage], flaglowair : "1", qcremark : comment , remarklowair : "", qcresult : "1"};
  qcList[cPage] = s;
  console.log(qcList);
  
  if(cPage<total-1){
    for(var Item in items ){
      list.push(true);
    }
    console.log(list);
    list[cPage] = true;
    list[cPage+1] = false;
    setQcHide(list);
    console.log(list);
    setComment("");
  }
if(cPage==total-2){
setLastPage(cPage+1);
setHideSend(false);
onSaveQc(cPage+1);

}
  
 // console.log(document.getElementsByName("C_docqc01")[0]);
 // console.log(document.getElementById("C_docqc01").textContent);
 // console.log(document.getElementById("A_docqc01"));
 // console.log(document.getElementById("B_docqc01").textContent);
}
const onBackQc = function(cPage:any) {
  if(cPage!=0){
    for(var Item in items ){
      list.push(true);
    }
    console.log(list);
    list[cPage] = true;
    list[cPage-1] = false;
    setQcHide(list);
    console.log(list);
    setComment("");
    setHideSend(true);
    
    //setCheckValue("");
    //setDocCheckId("");
  }
}
const listQc:any = [];
const rChange = function(v:any, t:any, i:any) {
  //setChangeRadio(v);
  checkValueList[i] = v;
  docCheckIdList[i] = t.doccheckid;

  console.log(comment);
  //console.log(qcList);
 // const s:Qc = {doccheckid : t.doccheckid, value : v, flaglowair : "1", qcremark : comment, remarklowair : "", qcresult : "1"};
 // qcList[i] = s;
  //setQcList(listQc);
  console.log(t.doccheckid);
  console.log(v);
  //console.log(listQc);
  //setCheckValue(v);
  //setDocCheckId(t.doccheckid);
  //setQcList(qcList);
}

const openQc = function(time:any, title:any) {
   if(time==1 && qcTime1){
      return false;
   }
   if(time==2 && qcTime2){
      return false;
   }
   if(isLowAir){
      setHideLowAir(false);
   }
   if(isHot){
      setHideHot(false);
   }
   console.log('scsccs');
   setUseQc(time);
   setHideQc(false);
   setHideTimeButton(true);
   setQcTitle("("+title+")"); 
 }
 const onClickBackQc = function() {
  setUseQc(0);
  setHideQc(true);
  setHideTimeButton(false);
  setQcTitle("");
  setHideSend(true);
}
const onBack = function() {
  setAuthPersisted();
  window.location.href = "/page/home/wp/wpIns/0/d";
}

const renders = function(){
    if(!hideHot){
      return (
        <IonItem>  
        <IonCol>
                  <IonItem>       
                    <IonCheckbox disabled={minD1} checked={min1}  slot="start" color="primary" onIonChange={e => {getChkHotValues(e, "MIN1", 0)}}></IonCheckbox>
                    <IonLabel>{"30 นาที"}</IonLabel>
                  </IonItem>
                  </IonCol>
                  <IonCol>
                  <IonItem>       
                    <IonCheckbox disabled={minD2} checked={min2}  slot="start" color="primary" onIonChange={e => {getChkHotValues(e, "MIN2", 0)}}></IonCheckbox>
                    <IonLabel>{"60 นาที"}</IonLabel>
                  </IonItem>
          </IonCol>
        </IonItem>
      )
      }
}
const render2 = function(){
  if(!hideHot){
    return (
      <IonItem>  
      <IonCol>
                    <IonItem>       
                      <IonCheckbox disabled={minD3} checked={min3}  slot="start" color="primary" onIonChange={e => {getChkHotValues(e, "MIN3", 0)}}></IonCheckbox>
                      <IonLabel>{"90 นาที"}</IonLabel>
                    </IonItem>
                    </IonCol>
                    <IonCol>
                    <IonItem>       
                      <IonCheckbox disabled={minD4} checked={min4}  slot="start" color="primary" onIonChange={e => {getChkHotValues(e, "MIN4", 0)}}></IonCheckbox>
                      <IonLabel>{"120 นาที"}</IonLabel>
                    </IonItem>
            </IonCol>         
      
      </IonItem>
    )
  }
}
const renderQc = function(){
  if(!hideQc){
    return (

      <IonItemDivider>       
      <IonLabel>
      <h1>ตรวจสอบความปลอดภัย</h1>
      </IonLabel>
     </IonItemDivider>

    )
  }
}
const renderCamera = function(){
  if(!hideQc){
    return (

      <IonContent hidden={hideQc}>
      <IonGrid>
      <IonRow>
        {photos.map((photo, index) => (
          <IonCol size="6" key={index}>
            <IonImg onClick={() => setPhotoToDelete(photo)} src={photo.webviewPath}  />
          </IonCol>
        ))}
      </IonRow>
    </IonGrid>

    <IonActionSheet
  isOpen={!!photoToDelete}
  buttons={[{
    text: 'Delete',
    role: 'destructive',
    icon: trash,
    handler: () => {
      if (photoToDelete) {
        deletePhoto(photoToDelete);
        setPhotoToDelete(undefined);
      }
    }
  }, {
    text: 'Cancel',
    icon: close,
    role: 'cancel'
  }]}
  onDidDismiss={() => setPhotoToDelete(undefined)}
/>


          <IonFab vertical="top" horizontal="center" slot="fixed">
            <IonFabButton onClick={() => takePhoto()}>
              <IonIcon icon={camera}></IonIcon>
            </IonFabButton>
            
           
          </IonFab>
        
</IonContent>

    )
  }
}
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
        <IonButtons onClick={(e) => onBack()} slot="start">
          <IonIcon icon={chevronBackOutline}></IonIcon>
          </IonButtons>
          <IonTitle>{name} :  {id}</IonTitle>
        </IonToolbar>
      </IonHeader>      
      <IonContent>

      <IonAlert
        isOpen={showAlert}
        onDidDismiss={() => setshowAlert(false)}
        cssClass="my-custom-class"
        header={'Message'}    
        message={'โปรดแนบรูปภาพ'}
        buttons={['OK']}
        />

      {!hideTimeButton ? (
                <IonGrid hidden={hideTimeButton}>
                <IonRow>
                  <IonCol></IonCol>
                  <IonCol size="8"> 
                    <IonCard onClick={(e) => openQc(1, "ก่อนเริ่มงาน")}>
                        <IonItem>
                          <IonThumbnail>
                            <IonImg src={"assets/img/"+buttonIconTime1+".png"} />
                          </IonThumbnail>             
                            <p>{"ก่อนเริ่มงาน"}</p>  
                        </IonItem> 
                    </IonCard>
                  </IonCol>
                  <IonCol></IonCol>
                </IonRow>
                <IonRow>
                  <IonCol></IonCol>
                  <IonCol size="8">
                  <IonCard onClick={(e) => openQc(2, "ระหว่างปฎิบัติงาน")}>
                        <IonItem>
                          <IonThumbnail slot="start">
                            <IonImg src={"assets/img/"+buttonIconTime2+".png"} />
                          </IonThumbnail>
                          <p>{"ระหว่างปฎิบัติงาน"}</p>  
                          
                        </IonItem> 
                    </IonCard>
                  </IonCol>
                  <IonCol></IonCol>
                </IonRow>
                <IonRow>
                  <IonCol></IonCol>
                  <IonCol size="8">
                  <IonCard onClick={(e) => openQc(3, "ปิดงาน")}>
                        <IonItem>
                          <IonThumbnail>
                            <IonImg src={"assets/img/"+buttonIconTime3+".png"} />
                          </IonThumbnail>
                          <p>{"ปิดงาน"}</p>  
                         
                        </IonItem> 
                    </IonCard>
                  </IonCol>
                  <IonCol></IonCol>
                </IonRow>
              </IonGrid>
      ) : ""}


     
   

      <IonContent hidden={hideQc}>   
      
      {!hideLowAir ?
        (
          
          <IonItemDivider  hidden={hideLowAir}>       
          <IonLabel>
          <h1>ตรวจสอบสถานที่อับอากาศ</h1>
          </IonLabel>
         </IonItemDivider>


        ) : ""}
        
    

      <IonList hidden={hideLowAir}>
     
      {qcLowAirList.map((text,i) => {
        
                if(text.docchecktype=='1' && !hideLowAir){
                    return(                
                      <IonItem key={i}>
                      <IonLabel class="ion-text-wrap">{text.labeltext}</IonLabel>
                      <IonCheckbox   onIonChange={e => {getChkValues(e, text, i)}} slot="end" color="primary" />
                    </IonItem>              
                    )
                }
                if(text.docchecktype=='2'  && !hideLowAir){
                  return(                
                    <IonItem key={i}>
                    <IonLabel class="ion-text-wrap">{text.labeltext}</IonLabel>
                    <IonInput  onIonInput={(e: any) => getTxtValues(e, text, i)}/>             
                    </IonItem>              
                  )
              }
            })}
    
      
    </IonList>
{!hideHot ? (
    <IonItemDivider hidden={hideHot}>       
    <IonLabel>
    <h1>การตรวจสอบก๊าซติดไฟ</h1>
    </IonLabel>
  </IonItemDivider>
) : ""}



<IonList hidden={hideHot}>

{!hideHot ? (
    <IonItemDivider color="secondary">
    <IonLabel>
    ก๊าซติดไฟ%LEL
    </IonLabel>
  </IonItemDivider>
) : ""}


{qcHotList.map((text,i) => {
    var h= false;
    if(useQc == 1 && text.doccheckid=='GAS1'){
      h = true
    }else if(useQc==2 && text.doccheckid=='GAS2'){
      h = true
    }else if(useQc==3 && (text.doccheckid=='GAS3' || text.doccheckid=='GAS4')){
      h = true
    }
    
    if(text.docchecktype=='1' && !hideHot && h){
      var v = false;
      if(text.flag1!=null && text.flag1!=''){
       v = true;
      }
        return(      
                
           <IonItem key={i}>
                <IonLabel class="ion-text-wrap">{text.labeltext}</IonLabel>
                <IonInput  readonly={v}  value={text.flag1} onIonInput={(e: any) => getTxtHotValues(e, text, i)}/>             
                </IonItem>      
        )
    }

})}
{!hideHot ? (
       <IonItemDivider color="secondary">
       <IonLabel>
       **มาตรฐานกำหนด  ก๊าซติดไฟ (น้อยกว่า 5 % LEL)
       </IonLabel>
     </IonItemDivider>
) : ""}

{!hideHot ? (

<IonItemDivider color="primary">
    <IonLabel>
    ออกซิเจน O₂ 
    </IonLabel>
  </IonItemDivider>

) : ""} 
 


  {qcHotList.map((text,i) => {
    var h = false;
    if(useQc==1 && text.doccheckid=="O2_1"){
      h = true
      console.log('h1 ::' +h);
    }else if(useQc==2 && text.doccheckid=="O2_2"){
      h = true
      console.log('h2 ::' +h);
    }else if(useQc==3 && (text.doccheckid=="O2_3" || text.doccheckid=="O2_4")){
      h = true
      console.log('h2 ::' +h);
    }
    
    if(text.docchecktype=='2' && !hideHot && h){
      var v = false;
      
      if(text.flag1!=null && text.flag1!=''){
       v = true;
      }
     
        return(                
           <IonItem key={i}>
                <IonLabel class="ion-text-wrap">{text.labeltext}</IonLabel>
                <IonInput readonly={v} value={text.flag1} onIonInput={(e: any) => getTxtHotValues(e, text, i)}/>             
                </IonItem>      
        )
    }

})}

{!hideHot ? (

<IonItemDivider color="primary">
    <IonLabel>
    **มาตรฐานกำหนด  ออกซิเจน 19.5-23.5  %
    </IonLabel>
  </IonItemDivider>

) : ""} 

{!hideHot ? (

<IonItemDivider color="warning">
<IonLabel class="ion-text-wrap">
 ตรวจสอบความปลอดภัย หลังจากปิดงาน (การปะทุของเชื้อไฟ หลังจากมีการเชื่อม / งานมีประกายไฟในพื้นที่)
</IonLabel>
</IonItemDivider>

) : ""} 

{renders()}
{render2()}



</IonList>


     
      {items.map((task,i) => {
                if(!hideQc &&!qcListHide[i]){
                  return(
                    <IonList key={i} hidden={qcListHide[i]}>
                    <IonRadioGroup key={i}   onIonChange={er => { rChange(er.detail.value, task, i)}}   name={task.doccheckid} value={checkValueList[i]}>
                  
                    <IonListHeader>
                     
                      <IonLabel>
                        QSSE ตรวจสอบ {qcTitle} {i+1} of {total}
                      </IonLabel>
                    </IonListHeader>
                    <IonItem> <IonLabel className="ion-text-wrap">{task.labeltext}</IonLabel></IonItem>
                    <IonItem>
                      <IonLabel>ปฏิบัติ</IonLabel>
                      <IonRadio slot="start"  value="A" />
                    </IonItem>
            
                    <IonItem>
                      <IonLabel>ไม่ได้ปฏิบัติ</IonLabel>
                      <IonRadio  slot="start"  value="B" />
                    </IonItem>
  
                    </IonRadioGroup>
                    <IonItem>
                     <IonLabel>หมายเหตุ</IonLabel>
                      <IonTextarea  onIonChange={ee => {saveComment(ee.detail.value, i)}}></IonTextarea>
                    </IonItem>
                  
                    <IonGrid>
                      <IonRow>
                        
                        <IonCol className="ion-text-center">
                        <IonButton size="small" fill="solid" color="primary" onClick={(e) => onBackQc(i)}><IonIcon icon={chevronBackOutline}></IonIcon>Back</IonButton>
                        <IonButton size="small" fill="solid" color="secondary" onClick={(e) => onSaveQc(i)}>Next<IonIcon icon={chevronForwardOutline}></IonIcon></IonButton>
                        
                        </IonCol>
                       
                      </IonRow>
                    </IonGrid>
                    </IonList>
                  )
                }

            })}

    {renderCamera()}


    </IonContent>



      </IonContent>
     
     {!hideSend ? 
     (
      <IonFooter>
      <IonButton hidden={hideSend} expand="block" size="small" fill="solid" color="success" onClick={(e) => onSendQc(lastPage)}><IonIcon icon={checkmarkDoneCircleOutline}></IonIcon>Send</IonButton>      
      </IonFooter>
     ) : ""}
   

     
    </IonPage>

    
  );
};

export default WpQc;
